import { Component } from "react";
import axios from "axios";
import myAxios from "./axiosilearnWrapper";
import Config from "../_config/config";
import UserService from "./UserService";

// Add the same error suppression interceptor to plain axios instance
axios.interceptors.response.use(
  response => response,
  error => {
    const url = error.config?.url || '';
    const status = error.response?.status;

    // Log auth/server errors
    if (status === 401 || status === 403) {
      console.warn('Authentication error (plain axios):', url);
    } else if (status === 500) {
      console.error('Server error (plain axios):', url, error.message);
    }

    // For flip class mode or lesson plan routes, suppress errors
    const isFlipClassRoute = url.includes('flip-class') ||
                             url.includes('lesson-plan') ||
                             url.includes('studyresource') ||
                             url.includes('study/resource');

    if (isFlipClassRoute && (status === 401 || status === 403 || status === 500)) {
      console.log('Suppressing error for flip class route (plain axios):', url);
      return Promise.resolve({
        data: { attachments: [], groups: [], lessons: [], data: [] },
        status: 200,
        statusText: 'OK (suppressed auth error)',
        headers: {},
        config: error.config
      });
    }

    return Promise.reject(error);
  }
);

class ApiService extends Component {
  fetchHome() {
    return axios.get(Config.apiUrl + "init/institute/home");
  }

  getActiveTheme() {
    return axios.get(Config.apiUrl + "init/theme");
  }

  getData(url) {
    return axios.get(url, {
      "access-control-allow-origin": "*",
    });
  }
  getDeviceId() {
    let deviceId = localStorage.getItem("ilearn-pwa-deviceId");
    if (!deviceId) {
      console.log("DeviceId Not found generating new");
      let sixdigitsrandom = Math.floor(100000 + Math.random() * 900000);
      deviceId = "PWA-" + sixdigitsrandom;
      localStorage.setItem("ilearn-pwa-deviceId", deviceId);
    }
    return deviceId;
  }

  generateEndPoint(postJSON) {
    let url = Config.apiUrl + "student/generate/push/endpoint";
    console.log(url);
    return axios.post(url, postJSON);
  }

  getTaskResources(postJSON) {
    var enquiryId = localStorage.getItem("enquiryId");
    let url = Config.apiUrl + "study/resource/enquiry/" + enquiryId;
    console.log(url);
    return axios.post(url, postJSON);
  }

  updateTaskResource(postJSON) {
    let url = Config.apiUrl + "study/resource/save/markdone";
    console.log(url);
    return axios.post(url, postJSON);
  }

  fetchLogin(username, password, metaData = null) {
    var dataString = {
      userName: username,
      password: password,
      deviceId: this.getDeviceId(),
    };
    if (metaData && Object.keys(metaData).length > 0) {
      dataString.metaData = metaData;
    }
    const url = Config.authBaseUrl + "rest/mobile/authenticate/user";
    console.log("Authentication URL:", url);
    console.log("Auth Backend:", Config.authBackend);
    return axios.post(url, dataString, {
      "access-control-allow-origin": "*",
    });
  }

  fetchLoginToken(token) {
    var dataString = {
      token: token,
      deviceId: this.getDeviceId(),
    };
    // Always use Java API directly for token login (Node doesn't support token login)
    const url = Config.siteUrl + "rest/mobile/authenticate/user";
    console.log("Token Authentication URL:", url);
    return axios.post(url, dataString, {
      "access-control-allow-origin": "*",
    });
  }

  verifyOTP(userId, otp) {
    var dataString = {
      userId: userId,
      otp: otp,
      deviceId: this.getDeviceId(),
    };
    return axios.post(Config.baseUrl + "verify/otp", dataString);
  }

  openIdLogin(credentials) {
    let url = Config.siteUrl + "rest/mobile/authenticate/user/openid";
    console.log(url);
    return axios.post(url, credentials);
  }

  fetchRegisterList() {
    return axios.get(Config.siteUrl + "api/common/quickEnquiry/form/3");
  }

  fetchRegister(data) {
    var dataString = data;
    //console.log("Register JSON : "+JSON.stringify(dataString));
    console.log(Config.siteUrl + "api/common/quickEnquiry/save/3");
    console.log(data);
    return axios.post(
      Config.siteUrl + "api/common/quickEnquiry/save/3",
      dataString
    );
  }

  fetchForgetpwd(username) {
    var dataString = {
      userName: username,
    };
    return axios.post(Config.nodeSiteUrl + "v1/password/recover", dataString);
  }

  fetchLoginUserName(registeredEmail) {
    var dataString = {
      registeredEmail: registeredEmail,
    };
    return axios.post(Config.apiUrl + "username/recover", dataString);
  }

  fetchResetpwd(username, otp, newPassword, confirmPassword) {
    var dataString = {
      userName: username,
      otp: otp,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    return axios.post(Config.nodeSiteUrl + "v1/password/reset", dataString);
  }

  fetchChangePwd(username, currentPassword, newPassword, confirmPassword) {
    var dataString = {
      userName: username,
      currentPassword: currentPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    return axios.post(Config.apiUrl + "password/edit", dataString);
  }

  fetchDashboard() {
    var enquiryId = localStorage.getItem("enquiryId");
    return myAxios.get(Config.nodeSiteUrl + "v1/dashboard/init/enquiry/" + enquiryId);
  }

  fetchTestList(url) {
    var enquiryId = localStorage.getItem("enquiryId");
    const fetchUrl =
      url || Config.apiUrl + "student/" + enquiryId + "/tests/category/0";
    return axios.get(fetchUrl);
  }

  fetchTest(testid) {
    var enquiryId = localStorage.getItem("enquiryId");
    var dataString = {
      deviceId: this.getDeviceId(),
      enquiryId: enquiryId,
      testId: testid,
    };
    return axios.post(Config.apiUrl + "test/download/init", dataString);
    //return axios.get(Config.testJSON + testid + '/' + testid +'.json');
  }

  testisActive(testid) {
    return axios.get(Config.siteUrl + "api/tm/" + testid + "/isActive");
    //return axios.get(Config.testJSON + testid + '/' + testid +'.json');
  }

  fetchTestJson(url) {
    // var enquiryId = localStorage.getItem('enquiryId');
    return axios.get(url);
  }

  endExam(json_data) {
    return axios.post(Config.apiUrl + "test/submit", json_data);
  }

  fetchTestPaperUploadStatus(testid) {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(
      Config.siteUrl +
        "api/common/student/" +
        enquiryId +
        "/test/" +
        testid +
        "/view/dvs/paper"
    );
  }

  fetchTestResult(body) {
    const url =
      "https://qtzeg3y5oc5iedabtawyzodfz40evpsi.lambda-url.ap-southeast-1.on.aws/?mode=analysis";
    console.log(url);
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    }).then((res) => res.json());
  }

  fetchDirectTestResult(testId, enquiryId) {
    return myAxios.get(
      Config.nodeSiteUrl + "v1/test-result/" + testId + "/student/" + enquiryId
    );
  }

  fetchDirectTestResultForAttempt(testId, enquiryId, attemptNumber) {
    return myAxios.get(
      Config.nodeSiteUrl + "v1/test-result/" + testId + "/student/" + enquiryId + "?attemptNumber=" + attemptNumber
    );
  }

  getTestAttemptInfo(testId, enquiryId) {
    return myAxios.get(
      Config.nodeSiteUrl + "v1/test-result/" + testId + "/student/" + enquiryId + "/attempts"
    );
  }

  initiateRetake(testId, enquiryId, enrollmentId) {
    return myAxios.post(
      Config.nodeSiteUrl + "v1/test-result/" + testId + "/student/" + enquiryId + "/retake",
      { enrollmentId }
    );
  }

  getTestCategoryWiseTestList(testCategoryId) {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(
      Config.apiUrl +
        "student/" +
        enquiryId +
        "/tests/category/" +
        testCategoryId
    );
  }

  getOnlineTestData(testId) {
    var enquiryId = localStorage.getItem("enquiryId");
    var enrollmentId = 0; //localStorage.getItem('enrollmentId');
    var url =
      Config.apiUrl +
      "student/" +
      enquiryId +
      "/enrollment/" +
      enrollmentId +
      "/test/" +
      testId;
    console.log(url);
    return axios.get(url);
  }

  submitTestData(testData) {
    var url = Config.apiUrl + "student/test/submit";
    console.log(url);
    return axios.post(url, testData);
  }

  syncTime(testData) {
    var url = Config.apiUrl + "student/test/sync/time";
    console.log(url);
    return axios.post(url, testData);
  }

  checkServer(enquiryId) {
    var url = Config.apiUrl + "student/" + enquiryId + "/test/server/status";
    console.log(url);
    return axios.get(url);
  }

  getTestAnalysis(testId) {
    var enquiryId = localStorage.getItem("enquiryId");
    var url =
      Config.apiUrl + "student/" + enquiryId + "/test/" + testId + "/analysis";
    console.log(url);
    return axios.get(url);
  }

  getQuizLeaderBoard() {
    var enquiryId = localStorage.getItem("enquiryId");
    var url = Config.siteUrl + "api/mobile/leaderboard/" + enquiryId;
    console.log(url);
    return axios.get(url);
  }

  getWalletTransactions(pageNumber) {
    var enquiryId = localStorage.getItem("enquiryId");
    var url =
      Config.siteUrl +
      "api/mobile/student/" +
      enquiryId +
      "/wallet/transactions/page/" +
      pageNumber;
    console.log(url);
    return axios.get(url);
  }

  fetchLearning(rid, rsid) {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(
      Config.apiUrl +
        "study/resource/type/" +
        rid +
        "/subtype/" +
        rsid +
        "/page/0/enquiry/" +
        enquiryId
    );
  }

  fetchLearningMetaData(moduleIdsJson) {
    var url = Config.apiUrl + "learningmodules/meta-data";
    console.log(url);
    console.log(moduleIdsJson);
    return axios.post(url, moduleIdsJson);
  }

  fetchStudentLearningActivities(payload) {
    var url = Config.apiUrl + "learningmodules/student-activity";
    console.log(url);
    console.log(payload);
    return axios.post(url, payload);
  }

  fetchLearningSteps(learnId) {
    return axios.get(Config.apiUrl + "lessonplan/" + learnId + "/steps");
  }

  fetchLearningStepsDesktop(learnId) {
    return myAxios.get(Config.desktopApi + "studyresources/lp/" + learnId);
  }

  markStudyResourceRead(studyResourceId, lessonPlanId) {
    return myAxios.post(Config.nodeSiteUrl + "v1/common/study-resource/mark-read", {
      studyResourceId,
      lessonPlanId,
    });
  }

  getLessonPlanProgress(lessonPlanId) {
    return myAxios.get(Config.nodeSiteUrl + "v1/common/lesson-plan/" + lessonPlanId + "/progress");
  }

  getFlipClassResources(enrollmentId, stepId) {
    // Get flip class resources filtered by current lesson status
    return myAxios.get(
      Config.nodeSiteUrl +
      "flip-class/student/" + enrollmentId + "/step/" + stepId + "/resources"
    );
  }

  fetchFlipClassConfig() {
    // Get flip class phase configuration from database
    return myAxios.get(Config.nodeSiteUrl + "v1/flip-class/config");
  }

  fetchLessonPlanWithTags(lessonPlanId, batchId, enquiryId) {
    // Get lesson plan structure with all resources and tags from Node backend
    // Pass batchId (preferred) or enquiryId to fetch step status information
    let url = Config.nodeSiteUrl + "v1/study-resources/lesson-plans/" + lessonPlanId;

    // Build query parameters - prefer batchId if available, fall back to enquiryId
    const params = [];
    if (batchId) {
      params.push("batchId=" + batchId);
    }
    if (enquiryId) {
      params.push("enquiryId=" + enquiryId);
    }

    if (params.length > 0) {
      url += "?" + params.join("&");
    }

    return myAxios.get(url);
  }

  fetchLearningStepAttachments(stepId, lessonPlanId) {
    // Migrated to Node backend instead of Java backend
    // Node backend returns full lesson plan structure, we'll extract step resources

    // Get batchId or enquiryId for access control
    const batchId = localStorage.getItem("batchId");
    const enquiryId = localStorage.getItem("enquiryId");

    let url = Config.nodeSiteUrl + "v1/study-resources/lesson-plans/" + lessonPlanId;

    // Build query parameters
    const params = [];
    if (batchId) {
      params.push("batchId=" + batchId);
    }
    if (enquiryId) {
      params.push("enquiryId=" + enquiryId);
    }
    if (params.length > 0) {
      url += "?" + params.join("&");
    }

    console.log("Fetching lesson plan from Node backend:", url);

    return myAxios.get(url).then((response) => {
      // Transform Node backend response to match Java backend format
      const lessonPlan = response.data;

      // Find the step with the given stepId
      let stepResources = [];
      if (lessonPlan.groups) {
        for (const group of lessonPlan.groups) {
          if (group.steps) {
            for (const step of group.steps) {
              if (step.id.toString() === stepId.toString()) {
                stepResources = step.resources || [];
                break;
              }
            }
          }
          if (stepResources.length > 0) break;
        }
      }

      // Helper function to map studyResourceTypeName to the type field expected by Resource.jsx
      const mapResourceType = (resource) => {
        if (resource.resourceType === 'test') return 'test';

        const typeName = resource.studyResourceTypeName?.toLowerCase() || '';

        // Map based on studyResourceTypeName
        if (typeName.includes('pdf') || typeName.includes('book') || typeName.includes('e-book')) {
          return 'book'; // PDF viewer will handle both PDFs and books
        } else if (typeName.includes('message')) {
          return 'message';
        } else if (typeName.includes('url') || typeName.includes('link')) {
          return 'url';
        } else if (typeName.includes('image')) {
          return 'image';
        } else if (typeName.includes('video')) {
          return 'streaming';
        }

        // Default to 'resource' for everything else
        return 'resource';
      };

      // Transform resources to match the format expected by Resource.jsx component
      const transformedResources = stepResources.map(resource => ({
        ...resource,
        // Add aliases for Resource.jsx component compatibility
        type: mapResourceType(resource),
        typeName: resource.studyResourceTypeName,
        typeId: resource.studyResourceTypeId,
        subTypeId: resource.studyResourceSubTypeId,
        publicUrl: resource.url,
        // Add studyResourceType for quiz/test detection in changeContent method
        studyResourceType: resource.resourceType === 'test' ? '0' : (resource.studyResourceTypeId?.toString() || '1'),
      }));

      // Return in the format expected by LearningStepAttachmentDetails
      // Include lesson-plan-level metaData so instructor details are available
      return {
        data: {
          attachments: transformedResources,
          metaData: lessonPlan.metaData || null
        }
      };
    });
  }

  fetchResources(rid, rsid) {
    var enquiryId = localStorage.getItem("enquiryId");
    let ran = Math.floor(100000 + Math.random() * 900000);
    let url =
      Config.apiUrl +
      "study/resource/type/" +
      rid +
      "/subtype/" +
      rsid +
      "/page/0/enquiry/" +
      enquiryId +
      "?var=" +
      ran;
    console.log(url);
    return axios.get(url);
  }

  fetchAttendance() {
    var enquiryId = localStorage.getItem("enquiryId");
    return myAxios.get(Config.nodeSiteUrl + "v1/attendance/summary/student/" + enquiryId);
  }

  fetchBiometricAttendance() {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(
      Config.apiUrl + "biometric/attendance/student/" + enquiryId + "/source/2"
    );
  }

  fetchProduct() {
    var enquiryId = localStorage.getItem("enquiryId");
    console.log(
      Config.siteUrl + "api/common/student/" + enquiryId + "/products"
    );
    return axios.get(
      Config.siteUrl + "api/common/student/" + enquiryId + "/products"
    );
  }

  getProduct(productId) {
    return axios.get(Config.siteUrl + "api/common/product/" + productId);
  }

  preOrderProduct(productId) {
    let enquiryId = localStorage.getItem("enquiryId");
    let url =
      Config.siteUrl +
      "rest/mobile/ilearn/student/" +
      enquiryId +
      "/product/" +
      productId +
      "/pre/order";
    console.log(url);
    return axios.get(url);
  }

  fetchReferrals() {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(Config.apiUrl + "student/" + enquiryId + "/referrals");
  }

  fetchRefer(data) {
    var dataString = data;
    return axios.post(Config.apiUrl + "student/refer", dataString);
  }

  fetchCountries() {
    return axios.get(Config.apiUrl + "countries/");
  }

  fetchAnalysis() {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(Config.baseUrl + "analysis/tests/" + enquiryId);
  }

  getNotificationMessages() {
    var enquiryId = localStorage.getItem("enquiryId");
    return myAxios.get(Config.nodeSiteUrl + "v1/dashboard/student/" + enquiryId + "/notification/messages");
  }

  getPayments() {
    var enquiryId = localStorage.getItem("enquiryId");
    let url = Config.siteUrl + "rest/mobile/payments/" + enquiryId;
    console.log(url);
    return axios.get(url);
  }

  // getPaymentDetails(enrollmentId) {
  //     let url = Config.siteUrl +"rest/mobile/payments/enrollment/"+enrollmentId;
  //     console.log(url);
  //     return axios.get(url);
  // }
  getPaymentDetails(enrollmentId, receiptSeriesId) {
    const url = `${Config.nodeSiteUrl}v1/enrollment/${enrollmentId}/plan-and-payments?receiptSeriesId=${receiptSeriesId}`;
    return myAxios.get(url);
  }

  getReceiptSeries(enrollmentId) {
    const url = `${Config.siteUrl}api/common/receiptseries?enrollmentId=${enrollmentId}`;
    return axios.get(url);
  }

  getPaymentHistory(enrollmentId) {
    let url = Config.siteUrl + "rest/mobile/payments/history/" + enrollmentId;
    console.log(url);
    return axios.get(url);
  }

  getTimeTables(data) {
    return axios.post(Config.siteUrl + "api/common/timetable/student", data);
  }

  getRecordedVideos(data) {
    return axios.post(
      Config.siteUrl + "api/common/timetable/student/viewVideos",
      data
    );
  }

  uploadFile(formData, testId) {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.post(
      Config.siteUrl +
        "api/common/student/" +
        enquiryId +
        "/test/" +
        testId +
        "/upload/dvs/paper",
      formData
    );
  }

  fetchExams(testCategoryIds, secondsActiveAfterExamSubmit) {
    var enquiryId = localStorage.getItem("enquiryId");
    return axios.get(
      Config.siteUrl +
        "api/tm/lists/category/" +
        testCategoryIds +
        "/enquiry/" +
        enquiryId +
        "/since/" +
        secondsActiveAfterExamSubmit
    );
  }

  getDiscussionBoards() {
    let url =
      Config.siteUrl +
      "rest/topics/discussionboards/mobile/user/" +
      UserService.getUserId();
    console.log(url);
    return axios.get(url);
  }

  getDiscussionBoardTopics(discussionBoardId) {
    let url =
      Config.siteUrl +
      "rest/topics/discussionboards/" +
      UserService.getUserId() +
      "/" +
      discussionBoardId;
    console.log(url);
    return axios.get(url);
  }

  getDiscussionBoardTopic(topicId) {
    let url =
      Config.siteUrl +
      "rest/topics/mobile/topic/" +
      UserService.getUserId() +
      "/" +
      topicId;
    console.log(url);
    return axios.get(url);
  }

  getDiscussionBoardQuestionTopic(questionId) {
    let url =
      Config.siteUrl +
      "rest/topics/mobile/topic/question/" +
      questionId +
      "/user/" +
      UserService.getUserId();
    console.log(url);
    return axios.get(url);
  }

  getDiscussionBoardResourceTopic(resourceId) {
    let url =
      Config.siteUrl +
      "rest/topics/mobile/topic/resource/" +
      resourceId +
      "/user/" +
      UserService.getUserId();
    console.log(url);
    return axios.get(url);
  }

  addTopic(topic) {
    let url = Config.siteUrl + "rest/topics/mobile/add";
    console.log(url);
    return axios.post(url, topic);
  }

  createComment(comment) {
    let url = Config.siteUrl + "rest/topics/comment";
    console.log(url);
    return axios.post(url, comment);
  }

  replyComment(comment) {
    let url = Config.siteUrl + "rest/topics/reply";
    console.log(url);
    return axios.post(url, comment);
  }

  deleteCommentOrReply(data) {
    let url = Config.siteUrl + "rest/topics/delete";
    console.log(url);
    return axios.post(url, data);
  }

  submitTest(testId, userId) {
    return axios.post(
      Config.siteUrl +
        "api/tm/" +
        testId +
        "/user/" +
        userId +
        "/submitAndPopulate"
    );
  }

  fetchInstantResult(testId, userId) {
    return axios.get(
      Config.nodeSiteUrl +
        "v1/quick-quiz/instant-result/" +
        testId +
        "?userId=" +
        userId
    );
  }

  checkTestStatus(testId) {
    var enquiryId = localStorage.getItem("enquiryId");
    let url =
      Config.desktopApi + "tm/" + testId + "/enquiry/" + enquiryId + "/status";
    return axios.get(url);
  }

  resumeStudyResourcesLearningActivity(Id) {
    let user = JSON.parse(localStorage.getItem("user")) || [];
    let url =
      Config.desktopApi +
      "studyresources/learningactivity/" +
      Id +
      "/track/last?token=" +
      user.token;
    return axios.get(url);
  }

  trackStudyResourcesLearningActivity(Id, data) {
    let user = JSON.parse(localStorage.getItem("user")) || [];
    let url =
      Config.desktopApi +
      "studyresources/learningactivity/" +
      Id +
      "/track?token=" +
      user.token;
    return axios.post(url, data);
  }

  saveStudyResourcesNotes(data, type) {
    // Use new nodefork endpoint
    let url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      data.resourceId +
      "/notes/save";

    // Transform payload to match new API format
    const payload = {
      userId: data.userId,
      note: data.note,
      assetMarker: data.time // Map 'time' to 'assetMarker'
    };

    return myAxios.post(url, payload);
  }

  getCertifyingLetterData() {
    let url = Config.apiUrl + "certify/letter";
    let user = JSON.parse(localStorage.getItem("user")) || {};
    let enquiryId = localStorage.getItem("enquiryId");
    let enrollmentId = user?.enrollmentBeans?.[0]?.enrollmentId;

    let postData = {
      enquiryId: enquiryId,
      userId: user.userId || user.id,
      enrollmentId: enrollmentId
    };

    console.log(url);
    return myAxios.post(url, postData);
  }
  updateStudyResourceNote(resourceId, userId, noteIndex, data) {
    // Use new nodefork endpoint for updating a note
    let url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      resourceId +
      "/user/" +
      userId +
      "/notes/" +
      noteIndex;

    const payload = {
      note: data.note,
      assetMarker: data.assetMarker
    };

    return myAxios.put(url, payload);
  }
  deleteStudyResourceNote(resourceId, userId, data) {
    // Use new nodefork endpoint
    let url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      resourceId +
      "/user/" +
      userId +
      "/notes/" +
      data.noteIndex;
    return myAxios.delete(url);
  }
  loadStudyResourcesNotes(resourceId, type) {
    // Use new nodefork endpoint
    let url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      resourceId +
      "/user/" +
      UserService.getUserId() +
      "/notes";
    return myAxios.get(url);
  }

  fetchStudyResourcesNotes(id) {
    let url =
      Config.desktopApi +
      "studyresources/lp/" +
      id +
      "/user/" +
      UserService.getUserId() +
      "/notes";
    return axios.get(url);
  }

  studentPayCheck(data) {
    let user = JSON.parse(localStorage.getItem("user")) || [];
    let url =
      Config.siteUrl + "api/common/student/access/paycheck?token=" + user.token;
    return axios.post(url, data);
  }

  studentTickerMessages() {
    var enquiryId = localStorage.getItem("enquiryId");
    let url = Config.nodeSiteUrl + "v1/study-resources/student/golden?tickerMessage=true";
    let payload = {
      enquiryId: enquiryId,
      resourceTypeId: 6,
      resourceSubTypeIds: "0"
    };
    return myAxios.post(url, payload);
  }

  initTestTaking(testId, paperUrl) {
    let url =
      Config.desktopApi +
      "tm/" +
      testId +
      "/user/" +
      UserService.getUserId() +
      "/initTestTaking";
    // var ip = require("ip");
    let data = {
      userAgent: navigator.userAgent,
      webCam: false,
      paperUrl
      // "ipAddress": ip.address(),
    };
    return axios.post(url, data);
  }

  fetchTodayTests(todayTestsConfig) {
    let enquiryId = localStorage.getItem("enquiryId");
    let url =
      Config.siteUrl +
      "rest/mobile/ilearn/student/" +
      enquiryId +
      "/today/tests";
    console.log(url);
    return axios.post(url, todayTestsConfig);
  }

  getFeedbackForm(formId, testId, employeeId, courseId, applicationUserId) {
    let enquiryId = localStorage.getItem("enquiryId");
    let userId = applicationUserId || 0;
    let url =
      Config.siteUrl +
      "api/studyresources/feedback/form/" +
      formId +
      "/enquiry/" +
      enquiryId +
      "/test/" +
      testId +
      "/instructor/" +
      employeeId +
      "/course/" +
      courseId +
      "?applicableToUserId=" +
      userId;
    console.log(url);
    return axios.get(url);
  }

  saveFeedbackForm(feedbackFormBean, testId, userId) {
    let enquiryId = localStorage.getItem("enquiryId");
    let url =
      Config.siteUrl +
      "api/studyresources/feedback/form/save/enquiry/" +
      enquiryId +
      "/user/" +
      userId +
      "/test/" +
      testId;
    console.log(url);
    return axios.post(url, feedbackFormBean);
  }

  getInstructorFeedbackForms() {
    let enquiryId = localStorage.getItem("enquiryId");
    let url = Config.apiUrl + "instructor/feedback/enquiry/" + enquiryId;
    console.log(url);
    return axios.get(url);
  }

  studentLevelPasswordCheck(testId, password) {
    let enquiryId = localStorage.getItem("enquiryId");
    var dataString = {
      testId: testId,
      enquiryId: enquiryId,
      password: password,
    };
    return axios.post(
      Config.desktopApi + "common/test/password/check/studentLevel",
      dataString
    );
  }

  examTimetable(id) {
    return myAxios.get(Config.desktopApi + "common/timetable/" + id);
  }

  examList() {
    return myAxios.post(
      Config.desktopApi + "common/program/student/timetables"
    );
  }
  dossierSection() {
    let enquiryId = UserService.getEnquiryId();
    return myAxios.get(
      Config.siteUrl + "api/common/gradecard/enquiry/" + enquiryId
    );
  }

  mentorTranscripts() {
    let enquiryId = UserService.getEnquiryId();
    return myAxios.get(
      Config.siteUrl + "api/common/mentees/studentdetails/" + enquiryId
    );
  }
  discipline() {
    let enquiryId = UserService.getEnquiryId();
    return myAxios.get(
      Config.siteUrl + "api/common/discipline/studentdetails/" + enquiryId
    );
  }

  convocationDetails() {
    let enquiryId = UserService.getEnquiryId();
    let url =
      Config.siteUrl +
      "api/common/convocation/student/details?enquiryId=" +
      enquiryId;
    return myAxios.get(url);
  }

  submitConvocationDetails(data) {
    let url = Config.siteUrl + "api/common/convocation/studentAttestation";
    return myAxios.post(url, data);
  }

  convocationStudentRegistration(data) {
    let url = Config.siteUrl + "api/common/convocation/studentRegistration";
    return myAxios.post(url, data);
  }

  questionWiseAnalysis(body) {
    // let enquiryId = UserService.getEnquiryId();
    // let url = Config.baseUrl + 'questionwiseanalysis/' + testid + '/' + enquiryId;
    const url =
      "https://qtzeg3y5oc5iedabtawyzodfz40evpsi.lambda-url.ap-southeast-1.on.aws/";
    console.log(url);
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    }).then((res) => res.json());
  }

  viewSolution(testId, currentIndex, attemptId) {
    let enquiryId = UserService.getEnquiryId();
    let url =
      Config.baseUrl +
      "viewsolution/test/" +
      testId +
      "/enquiry/" +
      enquiryId +
      "/enrollment/0/currentIndex/" +
      currentIndex +
      "/attempt/" +
      attemptId;
    console.log(url);
    return myAxios.get(url);
  }

  getTopRankers(testId) {
    let url = `${Config.siteUrl}api/common/test/${testId}/toprankers`;
    // https://triangles.studentdetails.com/api/common/test/250/toprankers
    return myAxios.get(url);
  }

  getStudentEnrollements() {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}api/common/student/information?enquiryId=${enquiryId}`;
    return myAxios.get(url);
  }

  verifyMobile(mobile, queryString) {
    // const url = `${Config.siteUrl}api/mobile/user/otp/channel/mobile/identifier/${mobile}`;
    const url = `https://4lkooqi5fbwptop7hgsas5hdnu0wyrig.lambda-url.ap-southeast-1.on.aws/?mobileNumber=91${mobile}&action=sendOTP&tenant=${Config.siteTitle}${queryString}`;

    console.log(url);
    // http://triangles.edusquares.com/api/mobile/user/otp/channel/mobile/identifier/8168224633
    return axios.get(url);
  }

  loginWithOtp(mobile, otp, queryString) {
    // const url = `${Config.siteUrl}api/mobile/user/otp/verify`;
    // http://triangles.edusquares.com/api/mobile/user/otp/verify
    // return axios.post(url,payload);
    const url = `https://4lkooqi5fbwptop7hgsas5hdnu0wyrig.lambda-url.ap-southeast-1.on.aws/?mobileNumber=91${mobile}&action=verifyOTP&otp=${otp}&tenant=${Config.siteTitle}${queryString}`;
    console.log(url);
    return axios.get(url);
  }

  fetchTestDetails() {
    const url = `${Config.siteUrl}${Config.siteTitle}/rest/mobile/user/admission/testdetails`;
    // https://unsat.edusquares.com/unsat/rest/mobile/user/admission/testdetails
    return myAxios.get(url);
  }

  fetchGoogleAnalytics() {
    const url = `https://tuningfork-live.s3.ap-southeast-1.amazonaws.com/${Config.siteTitle}/files/app-properties.json`;
    console.log(url);
    return axios.get(url);
  }

  resendTextOtp = (mobile) => {
    const url = `https://4lkooqi5fbwptop7hgsas5hdnu0wyrig.lambda-url.ap-southeast-1.on.aws/?mobileNumber=91${mobile}&action=retryText&tenant=${Config.siteTitle}`;
    console.log(url);
    return axios.get(url);
  };

  resendCallOtp = (mobile) => {
    const url = `https://4lkooqi5fbwptop7hgsas5hdnu0wyrig.lambda-url.ap-southeast-1.on.aws/?mobileNumber=91${mobile}&action=retryVoice&tenant=${Config.siteTitle}`;
    console.log(url);
    return axios.get(url);
  };

  testResumes = (body) => {
    const url = `https://5or2in4w2avvenkbbm2fpetjle0fijue.lambda-url.ap-southeast-1.on.aws/`;
    console.log(url);
    return fetch(url, {
      method: "POST",
      body,
    });
  };

  testResponses = (body) => {
    const url = `https://soaz3ulallctn6szdu3wwmgmaa0lkepj.lambda-url.ap-southeast-1.on.aws/`;
    console.log(url);
    return fetch(url, {
      method: "POST",
      body,
    });
  };

  testResultsUrls = (mobileNumber) => {
    const url = `${Config.siteUrl}api/mobile/user/admission/testresults?mobileNumber=${mobileNumber}`;
    console.log(url);
    return axios.get(url);
  };

  fetchGetUrl = (url) => {
    console.log(url);
    return axios.get(url);
  };

  updateProctoredProfile = (body) => {
    const url = `https://yazgub22cf6v3ry2cms3gvkhra0xmevx.lambda-url.ap-southeast-1.on.aws/`;
    console.log(url);
    return fetch(url, {
      method: "POST",
      body,
    });
  };

  uploadDocument = (body) => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}api/mobile/ilearn/enquiry/${enquiryId}/document/upload`;
    console.log(url);
    return myAxios.post(url, body);
  };

  trackPage(data) {
    let url = `${Config.siteUrl}api/common/log/page`;
    console.log(url);
    return myAxios.post(url, data);
  }

  uploadDoucment = (body, testId, questionId) => {
    const userId = UserService.getUserId();
    const url = `${Config.siteUrl}api/common/student/${userId}/test/${testId}/question/${questionId}/upload`;
    console.log(url);
    return myAxios.post(url, body);
  };

  getTestSubmission = (testId) => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}rest/mobile/viewsolution/test/${testId}/enquiry/${enquiryId}/enrollment/0/currentIndex/1/attempt/0`;
    return axios.get(url);
  };

  fetchMode3ExternalResult = (id) => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}rest/mobile/externalResult/${id}/${enquiryId}`;
    console.log(url);
    return axios.get(url);
  };

  checkForAttendance = (body) => {
    const token = UserService.getToken();
    const url = `${Config.siteUrl}api/common/student/access/attendancecheck?token=${token}`;
    console.log(url);
    return myAxios.post(url, body);
  };

  fetchQuestionPaper = (body) => {
    const url = `https://fazfu5ovtyloaojysslqrnfobq0kitms.lambda-url.ap-southeast-1.on.aws/`;
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    }).then((res) => res.json());
  };

  fetchDashboardUrl = (id) => {
    const url = `${Config.siteUrl}api/studyresources/getDashboardUrl/${id}`;
    console.log(url);
    return myAxios.get(url);
  };

  submitJeeAplicationDetails = (body) => {
    const url = `https://sndkzoujjielrmtxj2eypo2hii0zjzvv.lambda-url.ap-southeast-1.on.aws`;
    console.log(url);
    return fetch(url, {
      method: "post",
      body: body,
    });
  };

  checkJeeAplicationDetails = (body) => {
    const url = `https://sndkzoujjielrmtxj2eypo2hii0zjzvv.lambda-url.ap-southeast-1.on.aws?checkSave=true`;
    console.log(url);
    console.log(body);
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    });
  };

  fetchCurrentTime = () => {
    const url = `https://rmyo34tm4l7e77llimeksvi47u0cqntp.lambda-url.ap-southeast-1.on.aws/`;
    console.log(url);
    return fetch(url).then((res) => res.json());
  };

  saveUserData = (body) => {
    const url = `${Config.siteUrl}rest/mobile/enrollment/details/save`;
    console.log(url);
    return axios.post(url, body);
  };

  getUserFormId = (studentCode) => {
    const url = `${Config.siteUrl}rest/mobile/user/registration/form?mobileNumber=${studentCode}`;
    console.log(url);
    return myAxios.get(url);
  };

  fetchAdmitCardDetails = () => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}rest/mobile/user/enrollment/details?enquiryId=${enquiryId}`;
    console.log(url);
    return myAxios.get(url);
  };

  checkCoinsData = (body) => {
    const url =
      "https://sndkzoujjielrmtxj2eypo2hii0zjzvv.lambda-url.ap-southeast-1.on.aws/?checkSubscription=true";
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    }).then((res) => res.json());
  };

  deductCoins = (body) => {
    const url =
      "https://sndkzoujjielrmtxj2eypo2hii0zjzvv.lambda-url.ap-southeast-1.on.aws/?deductCoins=true";
    return fetch(url, {
      method: "post",
      body: JSON.stringify(body),
    }).then((res) => res.json());
  };

  fetchTestAnalysis = (categoryId) => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}rest/mobile/tests/performance/categoryId/${categoryId}/${enquiryId}`;
    console.log(url);
    return myAxios.get(url);
  };

  fetchCentresData = (testId) => {
    const url = `${Config.siteUrl}rest/mobile/test/user/centre/details?testId=${testId}`;
    console.log(url);
    return myAxios.get(url);
  };

  saveCentreDetails = (body) => {
    const url = `${Config.siteUrl}rest/mobile/test/user/centre/save`;
    console.log(url);
    return myAxios.post(url, body);
  };

  fetchZoomVideos = () => {
    const enquiryId = UserService.getEnquiryId();
    const url = `${Config.siteUrl}rest/mobile/ilearn/activityslot/studyresources/enquiry/${enquiryId}`;
    console.log(url);
    return myAxios.get(url);
  };

  fetchUrl = (url) => {
    console.log(url, "here");
    return axios.get(url);
  };

  fetchFormData = (formId) => {
    const url = `${Config.siteUrl}api/common/form/${formId}/schemaJson`;
    console.log(url);
    return myAxios.get(url);
  };

  submitApplicationForm = (data) => {
    const url = `${Config.siteUrl}api/landing/jsonform/enquiry/create`;
    console.log(url);
    return axios.post(url, data);
  };

  fetchRecomendationEngine = () => {
    const userId = UserService.getUserId();
    const url = `${Config.siteUrl}rest/mobile/recommendation/engine/user/${userId}`;
    console.log(url);
    return axios.get(url);
  };

  sendEmail = (body) => {
    const url = `${Config.siteUrl}rest/mobile/send/email`;
    console.log(url);
    return axios.post(url, body);
  };

  sendRegistrationMessage = (mobileNumber, name, date, time) => {
    const url = `https://4lkooqi5fbwptop7hgsas5hdnu0wyrig.lambda-url.ap-southeast-1.on.aws/?action=sendMessage&mobileNumber=91${mobileNumber}&stundentName=${name}&date=${date}${
      time ? `&time=${time}` : ""
    }`;
    console.log(url);
    return axios.get(url);
  };

  getStudentTicketTypes = () => {
    const url = `${Config.siteUrl}rest/students/ticket/student/types`;
    console.log(url);
    return myAxios.get(url);
  };

  sendStudentTicketDetails = (body) => {
    const url = `${Config.siteUrl}rest/students/ticket/details/save`;
    console.log(url);
    return myAxios.post(url, body);
  };

  fetchProgramDetails = (enrollmentId) => {
    // enquiryId url
    // const enquiryId = localStorage.getItem('enquiryId');
    // const url = `${Config.siteUrl}rest/students/student/${enquiryId}/program/details`;

    const url = `${Config.siteUrl}rest/students/student/enrollment/${enrollmentId}/program/details`;
    return myAxios.get(url);
  };

  fetchAllTest = () => {
    const enquiryId = localStorage.getItem("enquiryId");
    const url = `${Config.nodeSiteUrl}v1/student/${enquiryId}/all-tests`;
    return myAxios.get(url);
  };

  verifyMicrosoftToken = (token) => {
    const url = `https://meman2zf2a2lbyafipwhvqrjru0wvrqi.lambda-url.ap-southeast-1.on.aws/?tenant=${Config.siteTitle}`;
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json());
  };

  getMessageDetails = (userId) => {
    const url = `${Config.siteUrl}api/common/student/view/message/${userId}`;
    console.log(url);
    return axios.get(url);
  };

  getVdoCipherOtp = (videoId) => {
    const url = `https://w2kzlmanhlmlmmzanasicnxkou0nnwtn.lambda-url.ap-southeast-1.on.aws/?videoId=${videoId}`;
    console.log(url);

    return myAxios.get(url);
  };

  fetchResourceTimeSpent = (body) => {
    const url = `${Config.siteUrl}api/common/generate/genericreport/report/8`;
    console.log(url);
    return myAxios.post(url, body);
  };

  unsatBatchUpdate = (body) => {
    const url = `${Config.siteUrl}rest/common/enrollment/batch/update`;
    console.log(url);
    return myAxios.post(url, body);
  };

  getS3SignedKey = (body) => {
    const url = `https://wu6wfeyishrmjyrnbydzxfbl2i0ldoef.lambda-url.ap-southeast-1.on.aws/?mode=getS3SignedKey`;
    console.log(url);
    return myAxios.post(url, body);
  };

  getLearningTimeSpent = (userName, credentials, baseUrl) => {
    async function fetchAllStatements(url, results = []) {
      console.log(url);
      const response = await axios.get(url, {
        headers: {
          Authorization: `Basic ${btoa(
            `${credentials.key}:${credentials.secret}`
          )}`,
          "x-experience-api-version": "1.0.1",
        },
      });
      results.push(...response.data.statements);

      if (response.data.more) {
        const nextUrl = `${baseUrl}${response.data.more}`;
        return fetchAllStatements(nextUrl, results);
      }

      return results;
    }

    return fetchAllStatements(
      `${baseUrl}/data/xAPI/statements?agent={"mbox": "https://${Config.siteTitle}.edusquares.com|${userName}"}&verb=http://edusquares.com/xapi/verbs/played&limit=1000`
    );
  };

  getAllCountries = () => {
    const url = `${Config.siteUrl}rest/common/countries`;

    return myAxios.get(url);
  };

  updateStudentAddress = (body) => {
    const url = `${Config.siteUrl}rest/students/address/update`;

    return myAxios.post(url, body);
  };

  acceptCashPayment = (body) => {
    const url = `${Config.siteUrl}api/students/pay/using/invoice`;
    console.log(url);
    return myAxios.post(url, body);
  };

  acceptCashPaymentWithToken = (body, token) => {
    const url = `${Config.siteUrl}api/students/pay/using/invoice`;
    console.log(url);
    return axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  fetchBrowseByDomainTags = () => {
    const url = `${Config.siteUrl}rest/mobile/tags?appliesTo=product`;
    console.log(url);
    return myAxios.get(url);
  };

  getProductViews = (body) => {
    const url = `${Config.siteUrl}rest/mobile/product/views`;
    console.log(url);
    return myAxios.post(url, body);
  };

  setDailyTargetTime = (body) => {
    const url = `${Config.siteUrl}rest/mobile/user/dailytarget/save`;
    return myAxios.post(url, body);
  };

  fetchDailyTargetTime = (userId) => {
    const url = `${Config.siteUrl}rest/mobile/user/${userId}/timespent`;
    console.log(url);
    return myAxios.get(url);
  };

  updateLearningModuleStatus = (body) => {
    const url = `${Config.siteUrl}rest/mobile/learningmodule/status/save`;
    return myAxios.post(url, body);
  };

  initiateLearningModuleStatusRecord = (body) => {
    const url = `${Config.siteUrl}rest/mobile/learningmodule/intialize`;
    return myAxios.post(url, body);
  };

  createOrUpdateAvatar = (enquiryId, body) => {
    const url = `${Config.siteUrl}rest/mobile/ilearn/enquiry/${enquiryId}/upload/avatar`;
    console.log(body);
    return myAxios.post(url, body);
  };

  deleteAvatar = (enquiryId) => {
    const url = `${Config.siteUrl}rest/mobile/ilearn/enquiry/${enquiryId}/delete/avatar`;
    return myAxios.get(url);
  };
  fetchBadges = (enrollmentId) => {
    const url = `${Config.siteUrl}rest/mobile/enrollment/${enrollmentId}/tagmappings`;
    return myAxios.get(url);
  };
  createHelpTicket = (body) => {
    const url = `${Config.siteUrl}rest/mobile/ilearn/ticket/add`;
    return myAxios.post(url, body);
  };
  updateProfile = (body) => {
    const url = `${Config.siteUrl}rest/landing/enquiry/update`;
    return myAxios.post(url, body);
  };

  updateAndFetchRSVPStatus = (body) => {
    const url = `${Config.siteUrl}api/common/user/rsvp`;
    return myAxios.post(url, body);
  };

  fetchHelpServiceData = () => {
    const url = `https://tuningfork-static-file-server.s3.ap-southeast-1.amazonaws.com/assets/tenants/${Config.siteTitle}/customer-details.json`;
    console.log(url);
    return axios.get(url);
  };

  getUserStudyResourceBookmarks() {
    const url = `${Config.siteUrl}api/common/fetch/user/${UserService.getUserId()}/bookmarks`;
    return myAxios.get(url);
  }

  // Get bookmark status for a specific resource
  getBookmarkStatus(resourceId, userId) {
    const url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      resourceId +
      "/user/" +
      userId +
      "/bookmark";
    return myAxios.get(url);
  }

  // Toggle bookmark for a specific resource
  toggleBookmark(resourceId, userId, bookmark) {
    const url =
      Config.nodeSiteUrl +
      "v1/study-resources/" +
      resourceId +
      "/bookmark";

    const payload = {
      userId: userId,
      bookmark: bookmark
    };

    return myAxios.post(url, payload);
  }

  // Legacy method - keeping for backward compatibility if needed elsewhere
  userStudyResourceBookmarks(body) {
    const url = `${Config.siteUrl}api/common/bookmark/user/studyresource`;
    return myAxios.post(url, body);
  }

  getAlumniRegistrationFormData = async () => {
    const url = `${Config.nodeSiteUrl}v1/alumni/registration-form`;

    return axios.get(url);
  };

  registerAlumni = (data) => {
    const url = `${Config.nodeSiteUrl}v1/alumni`;
    return axios.post(url, data);
  };

  fetchUserCertificates = (userId) => {
    const url = `${Config.siteUrl}api/common/fetch/user/${userId}/certificates`;
    return myAxios.get(url);
  };

  checkUniqueUsername = (username) => {
    const url = `${Config.nodeSiteUrl}v1/users/check-username?username=${username}`;
    console.log(url);
    return axios.get(url);
  };

  fetchAllUserNotes = () => {
    let url = `${
      Config.siteUrl
    }api/common/fetch/user/${UserService.getUserId()}/notes`;
    return myAxios.get(url);
  };

  getActivitySlotTemplates = (body) => {
    const url = `${Config.siteUrl}api/common/fetch/activityslot/templates`;
    return myAxios.post(url, body);
  };

  scheduleActivitySlotForUser = (body) => {
    const url = `${Config.siteUrl}api/common/schedule/user/activityslot`;
    return myAxios.post(url, body);
  };

  fetchUserScheduledActivitySlots = (body) => {
    const url = `${Config.siteUrl}api/common/fetch/user/activityslot/booking`;
    return myAxios.post(url, body);
  };

  getStudentSchedule = (enrollmentId, params) => {
    const url = `${Config.nodeSiteUrl}v1/schedules/student/${enrollmentId}`;
    console.log(url);
    return myAxios.get(url, { params });
  };

  verifyValidUser = () => {
    const userId = UserService.getUserId();
    const baseUrl = Config.authBackend === 'node' ? `${Config.nodeSiteUrl}v1/` : Config.siteUrl;
    const url = `${baseUrl}rest/mobile/verifyuser/${userId}/status`;
    return myAxios.get(url);
  };

  fetchProgramIntakes = () => {
    const url = `${Config.nodeSiteUrl}v1/program-details`;
    console.log(url);
    return axios.get(url);
  };

  fetchProgramModules = (programId, intakeId) => {
    const url = `${Config.nodeSiteUrl}v1/program-details/programs/${programId}/intakes/${intakeId}`;
    console.log(url);
    return axios.get(url);
  };

  fetchDefaultCurrency = () => {
    const url = `${Config.nodeSiteUrl}v1/currencies/default`;
    console.log(url);
    return axios.get(url);
  };

  fetchDeliveryFormats = () => {
    const url = `${Config.nodeSiteUrl}v1/program-details/delivery-formats`;
    console.log(url);
    return axios.get(url);
  };

  saveCartData = (body)=>{
    const url = `${Config.nodeSiteUrl}v1/cart`;
    console.log(url);
    return axios.post(url, body);
  }

  trackCertifyingLetterDownload = (userId, verb, enrollmentId) => {
    const url = `${Config.baseUrl}track/certifying/letter/downloads`;
    const data = {
      userId: userId,
      verb: verb,
      enrollmentId: enrollmentId
    };
    console.log(url);
    return myAxios.post(url, data);
  }

  
  registerModules = (body)=>{
    const url = `${Config.siteUrl}api/common/request/course/approval/advisor`
    return myAxios.post(url, body);
  }
  deRegisterModules = (body)=>{
    const url = `${Config.siteUrl}api/common/request/course/deregister`
    return myAxios.post(url, body);
  }
  fetchLearningAnalytics = (userId) => {
    const url = `${Config.siteUrl}api/studyresources/user/${userId}/learninganalytics`;
    console.log(url);
    return myAxios.get(url);
  }

  fetchTickets = (body)=>{
    const url = `${Config.siteUrl}api/students/ticket/details/search`;
    return myAxios.post(url, body);
  }

  fetchGoldenStudyResources(postData) {
    const url = `${Config.nodeSiteUrl}v1/study-resources/student/golden`;
    const payload = {
      ...postData,
      fromLearningModules: postData.fromLearningModules !== undefined ? postData.fromLearningModules : false
    };
    console.log(url);
    return myAxios.post(url, payload);
  }

  fetchRecentGoldenOnlineTests(postData) {
    const url = `${Config.siteUrl}api/golden/recent/onlineTests`;
    const payload = {
      ...postData,
      fromLearningModules: postData.fromLearningModules !== undefined ? postData.fromLearningModules : false
    };
    console.log(url);
    return myAxios.post(url, payload);
  }

    generateQueryResponse = (body) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/prompt`;
    return myAxios.post(url, body);
  };

  // PlayGround APIs
  getPlaygroundTags() {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/tags");
  }

  getPlaygroundTagChildren(tagId) {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/tags/" + tagId);
  }

  getPlaygroundQuestions(filters) {
    return myAxios.post(Config.nodeSiteUrl + "v1/playground/questions", filters);
  }

  savePlaygroundAttempt(data) {
    return myAxios.post(Config.nodeSiteUrl + "v1/playground/attempt/save", data);
  }

  getPlaygroundSolution(questionId) {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/questions/" + questionId + "/solution");
  }

  postPlaygroundDoubt(data) {
    return myAxios.post(Config.nodeSiteUrl + "v1/playground/questions/doubt/post", data);
  }

  getPlaygroundFullSyllabusTests() {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/full-syllabus-tests");
  }

  getPlaygroundCompetencyTags(subjectTagId) {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/competency-tags?subjectTagId=" + subjectTagId);
  }

  getPlaygroundAnalyticsOverview() {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/analytics/overview");
  }

  getPlaygroundAnalyticsPerformance() {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/analytics/performance");
  }

  getPlaygroundAnalyticsWeakAreas() {
    return myAxios.get(Config.nodeSiteUrl + "v1/playground/analytics/weak-areas");
  }
  // Proctored Tests
  getProctoredTests() {
    const enquiryId = localStorage.getItem("enquiryId");
    const url = `${Config.nodeSiteUrl}v1/proctored-tests/student/${enquiryId}`;
    return myAxios.get(url);
  }

  getAvailableProctoredTestSlots(testId) {
    const enquiryId = localStorage.getItem("enquiryId");
    const url = `${Config.nodeSiteUrl}v1/proctored-tests/${testId}/slots?enquiryId=${enquiryId}`;
    return myAxios.get(url);
  }

  bookProctoredTestSlot(testId, slotId) {
    const enquiryId = localStorage.getItem("enquiryId");
    const url = `${Config.nodeSiteUrl}v1/proctored-tests/book-slot`;
    return myAxios.post(url, { enquiryId: Number(enquiryId), testId, slotId });
  }

  getProctoredTestTicket(bookingId) {
    const url = `${Config.nodeSiteUrl}v1/proctored-tests/ticket/${bookingId}`;
    return myAxios.get(url);
  }

  verifyFace(payload) {
    const url = `https://qtzeg3y5oc5iedabtawyzodfz40evpsi.lambda-url.ap-southeast-1.on.aws/?mode=verifyFace`;
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
    }).then((res) => res.json());
  }
}

export default new ApiService();
